import React from "react";
import SandwichMaterialImg from "../../../resources/assets/images/bananeira2.png";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";

function SandwichMaterial() {
  const mdMediaQuery = useMediaQuery("(min-width:1024px)");
  const { t } = useTranslation();
  return (
    <div className="w-full flex flex-row lg:h-fit">
      <div
        className="flex p-6 lg:p-0 flex-col items-center lg:basis-1/2 w-full lg:bg-white lg:py-10"
        style={{
          backgroundImage: !mdMediaQuery && `url(${SandwichMaterialImg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <div className="p-6 lg:p-0 lg:px-6 flex flex-col items-center h-fit lg:bg-white bg-[#006536CC]">
          <div className="lg:text-[#1B7E6C] text-white lg:font-bold font-medium lg:text-[40px] text-[32px] uppercase text-center lg:h-56 mb-5 lg:mb-0">
            {t("material.title")}
          </div>
          <div className="lg:text-black text-white lg:text-lg text-base font-normal lg:text-justify text-center">
            {t("material.text.par1")}
          </div>
          <div className="lg:text-black mt-7 text-white lg:text-lg text-base font-normal lg:text-justify text-center">
            {t("material.text.par2")}
          </div>
          <div className="lg:hidden mt-7 flex text-white text-base font-normal text-center">
            {t("material.text.par3")}
          </div>
          <div className="lg:hidden mt-7 flex text-white text-base font-normal text-center">
            {t("material.text.par4")}
          </div>
        </div>
      </div>
      <div
        className="lg:flex lg:basis-5/12 hidden"
        style={{
          backgroundImage: `url(${SandwichMaterialImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="lg:flex lg:basis-1/2 hidden px-6 lg:py-10">
        <div className="flex flex-col items-center justify-center h-fit">
          <div className="lg:h-56 w-full" />
          <div className="text-black text-lg font-normal lg:text-justify">
            {t("material.text.par3")}
          </div>
          <div className="text-black text-lg font-normal lg:text-justify mt-7">
            {t("material.text.par4")}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SandwichMaterial;
